import React from "react"
import { Flex, Box, Text } from "theme-ui"
import _ from "lodash"
import { faMinus } from '@fortawesome/free-solid-svg-icons'

import TextField from "../Radiate/TextField/TextField"
import NewBoxButton from "../Radiate/NewBoxButton/NewBoxButton"

import * as Styles from "./BusinessInfoStyles"
const Address = ({
  address,
  onChangeAddress,
  index,
  businessInfo
}) => {
  return (
    <Box
      p={2}
      mb={1}
      mx={1}
      mt={3}
      sx={{
        borderRadius: "8px",
        border: "1px solid #e8e7e8",
      }}>
      <Box pb={2}>
        <Flex sx={{ justifyContent: "space-between"}}>
          <Text sx={{ fontSize: "1", color: "#bbbbbc"}}>Address #{index + 1}</Text>
          <NewBoxButton
            icon={faMinus}
            onClick={() => {
              const modBusinessInfo = _.cloneDeep(businessInfo)
              const modAddresses = [
                ...modBusinessInfo.profile.addresses.slice(0, index),
                ...modBusinessInfo.profile.addresses.slice(index + 1)
              ]
              modBusinessInfo.profile.addresses = modAddresses
              onChangeAddress(modBusinessInfo)
            }}
          />
        </Flex>
        <TextField
          label="Title"
          maxLength={42}
          borderStyle
          useInput
          value={address.alias}
          onChange={(e) => {
            const modBusinessInfo = _.cloneDeep(businessInfo)
            modBusinessInfo.profile.addresses[index].alias = e.target.value
            onChangeAddress(modBusinessInfo)
            // setBusinessInfo(modBusinessInfo)
          }}
        />
      </Box>
      <Box pb={2}>
        <TextField
          label="Line 1"
          borderStyle
          useInput
          value={address.line1}
          onChange={(e) => {
            const modBusinessInfo = _.cloneDeep(businessInfo)
            modBusinessInfo.profile.addresses[index].line1 = e.target.value
            onChangeAddress(modBusinessInfo)
            // setBusinessInfo(modBusinessInfo)
          }}
        />
      </Box>
      <Box pb={2}>
        <TextField
          label="Line 2"
          borderStyle
          useInput
          value={address.line2}
          onChange={(e) => {
            const modBusinessInfo = _.cloneDeep(businessInfo)
            modBusinessInfo.profile.addresses[index].line2 = e.target.value
            onChangeAddress(modBusinessInfo)
            // setBusinessInfo(modBusinessInfo)
          }}
        />
      </Box>
      <Flex pb={2} sx={{ justifyContent: "space-between" }}>
        <Styles.FlexTextField
          sx={{ paddingRight: "4px", width: "30%" }}
          label="City"
          borderStyle
          useInput
          value={address.city}
          onChange={(e) => {
            const modBusinessInfo = _.cloneDeep(businessInfo)
            modBusinessInfo.profile.addresses[index].city = e.target.value
            onChangeAddress(modBusinessInfo)
            // setBusinessInfo(modBusinessInfo)
          }}
        />
        <Styles.FlexTextField
          label="State"
          useInput
          borderStyle
          value={address.state}
          onChange={(e) => {
            const modBusinessInfo = _.cloneDeep(businessInfo)
            modBusinessInfo.profile.addresses[index].state = e.target.value
            onChangeAddress(modBusinessInfo)
            // setBusinessInfo(modBusinessInfo)
          }}
        />
        <Styles.FlexTextField
          label="Zip"
          borderStyle
          useInput
          value={address.zip}
          onChange={(e) => {
            const modBusinessInfo = _.cloneDeep(businessInfo)
            modBusinessInfo.profile.addresses[index].zip = e.target.value
            onChangeAddress(modBusinessInfo)
            // setBusinessInfo(modBusinessInfo)
          }}
        />
      </Flex>
    </Box>
  )
}

 export default Address